// Inquiry segment constants for filtering inquiries based on time periods
export const INQUIRY_SEGMENTS = {
  ALL: 'all',
  OVERDUE: 'overdue',
  CURRENT: 'current',
  UPCOMING: 'upcoming',
};

/** Default segment when visiting /inquiries or an invalid segment URL */
export const INQUIRY_SEGMENTS_DEFAULT = INQUIRY_SEGMENTS.CURRENT;

const VALID_INQUIRY_SEGMENTS = new Set(Object.values(INQUIRY_SEGMENTS));

/** @param {unknown} value */
export const isInquirySegment = (value) =>
  typeof value === 'string' && VALID_INQUIRY_SEGMENTS.has(value);
